import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Message, Thread } from 'app/messages/message-service/message.model';
import { Contact } from 'app/models/dto/contact.model';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';

interface Recipient {
    bcc: number;
    email: string;
    messageId: number;
    name: string;
    opens: number | null;
    status: string;
    sent: string;
}

@Component({
    selector: 'app-email-content',
    templateUrl: './email-content.component.html',
    styleUrls: ['./email-content.component.scss']
})
export class EmailContentComponent implements OnInit, OnChanges, AfterViewInit {

    @Input() activeEmailThread: Thread | null;
    @Input() borrower: Borrower;
    @Input() lenderUser: LenderUser;
    @Input() loadingActiveEmailThread: boolean;
    @Input() joinedContacts: Contact[];
    @Output() emailCreate = new EventEmitter();
    @ViewChild('emailContentContainer') emailContentContainer: ElementRef;

    subject: string = '';
    messageCount: number = 0;
    toRecipientRecords: Recipient[] = [];
    bccRecipientRecords: Recipient[] = [];
    lastMessageHeight: number;
    showAsMarketing: boolean;

    constructor() {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        if (!!this.lastMessageHeight) {
            this.scrollToRecentEmail();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.activeEmailThread && !!this.activeEmailThread) {
            this.doesItLookLikeMarketing(this.activeEmailThread);
            this.setSubject(this.activeEmailThread);
            this.setMessageCount(this.activeEmailThread);
            this.setReplyEmails(this.activeEmailThread);
        }
    }

    setSubject(thread: Thread): void {
        this.subject = thread.messages[0].subject ?? '';
    }

    setMessageCount(thread: Thread): void {
        this.messageCount = thread.messages.length ?? 0;
    }

    setReplyEmails(thread: Thread): void {
        this.toRecipientRecords = [];
        this.bccRecipientRecords = [];
        thread.messages.map((message) => {
            message.recipientRecords?.map((re: Recipient) => {
                const i = this.toRecipientRecords?.findIndex(x => {
                    return ((x.name === re.name) && (x.email === re.email) && (x.bcc === 0));
                });
                if (!!i && i === -1) {
                    !!re.bcc ? this.bccRecipientRecords.push(re) : this.toRecipientRecords.push(re);
                }
            });
        });
    }

    trackById(model: any) {
        return model.id;
    }

    handleEmailCreate(message: Message): void {
        this.emailCreate.emit(message);
    }

    scrollIntoView(lastMessageHeight: number): void {
        this.lastMessageHeight = lastMessageHeight;
        if (!!this.emailContentContainer) {
            this.scrollToRecentEmail();
        }
    }

    scrollToRecentEmail(): void {
        this.emailContentContainer.nativeElement.scrollTop = this.emailContentContainer.nativeElement.scrollHeight - this.lastMessageHeight;
    }

    doesItLookLikeMarketing(thread: Thread): void {
        this.showAsMarketing = thread.messages.every(x => !!x.hubspotEmailTemplateId);
    }
}
